import { Badge } from "@/components/common";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

type ServiceSectionProps = {
  badge: string;
  title: string;
  icon: ReactNode;
  iconBgColor?: string;
  iconColor?: string;
  description: ReactNode;
  buttonText: string;
  buttonLink: string;
  isExternalLink?: boolean;
  bgColor?: string;
};

const ServiceSection = ({
  badge,
  title,
  icon,
  iconBgColor = "bg-[#fff3e0]",
  description,
  buttonText,
  buttonLink,
  isExternalLink = false,
  bgColor,
}: ServiceSectionProps) => {
  return (
    <section className="mt-[60px] last:mb-0">
      <Badge outline color="text-gray-600" size="sm" className="mb-5 font-semibold shadow">
        {badge}
      </Badge>
      <h2 className="text-[2.6rem] font-bold text-[#1a1a1a] mb-8 leading-tight">{title}</h2>

      <div className={`flex items-center justify-between p-8 ${bgColor} rounded-2xl shadow-sm`}>
        <div className="flex items-start flex-1 gap-7">
          {/* Icon */}
          <div
            className={`w-[72px] h-[72px] rounded-full ${iconBgColor} flex items-center justify-center flex-shrink-0 mt-1`}
          >
            {icon}
          </div>

          {/* Content */}
          <div className="flex-1 pt-1">{description}</div>
        </div>

        {/* CTA Button */}
        {isExternalLink ? (
          <a
            href={buttonLink}
            className="ml-6 px-7 py-5 bg-white shadow-md rounded-lg text-[1.5rem] font-semibold text-[#333333] hover:bg-gray-50 hover:border-gray-400 transition-all whitespace-nowrap"
          >
            {buttonText}
          </a>
        ) : (
          <Link
            to={buttonLink}
            className="ml-6 px-7 py-5 bg-white shadow-md rounded-lg text-[1.5rem] font-semibold text-[#333333] hover:bg-gray-50 hover:border-gray-400 transition-all whitespace-nowrap"
          >
            {buttonText}
          </Link>
        )}
      </div>
    </section>
  );
};

export default ServiceSection;
